var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1746 17.1501H6.99961C5.56628 17.1501 4.34961 16.6501 3.34961 15.6501C2.34961 14.6501 1.84961 13.4334 1.84961 12.0001C1.84961 10.5668 2.34961 9.3501 3.34961 8.3501C4.34961 7.3501 5.56628 6.8501 6.99961 6.8501H11.1746V8.5501H6.99961C6.03294 8.5501 5.21628 8.88343 4.54961 9.5501C3.88294 10.2168 3.54961 11.0334 3.54961 12.0001C3.54961 12.9501 3.88294 13.7626 4.54961 14.4376C5.21628 15.1126 6.03294 15.4501 6.99961 15.4501H11.1746V17.1501ZM8.02461 12.7751V11.2251H15.9746V12.7751H8.02461ZM12.8246 17.1501V15.4501H16.9996C17.9663 15.4501 18.7829 15.1168 19.4496 14.4501C20.1163 13.7834 20.4496 12.9668 20.4496 12.0001C20.4496 11.0501 20.1163 10.2376 19.4496 9.5626C18.7829 8.8876 17.9663 8.5501 16.9996 8.5501H12.8246V6.8501H16.9996C18.4329 6.8501 19.6496 7.3501 20.6496 8.3501C21.6496 9.3501 22.1496 10.5668 22.1496 12.0001C22.1496 13.4334 21.6496 14.6501 20.6496 15.6501C19.6496 16.6501 18.4329 17.1501 16.9996 17.1501H12.8246Z",
    fill: "#12246C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2985b78da65717106c83d33f1ce7e5f1.svg";
export { ForwardRef as ReactComponent };